import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { ENV } from '@app/env';
import { StompConfig, StompRService, StompState } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { Events } from 'ionic-angular';
import { Observable, Subscription } from 'rxjs';
import * as SockJS from 'sockjs-client';

import { APP_CONFIG } from '../../app.config';
import { WebSocketType } from '../enums/websocket.enum';
import { RequestService } from './request.service';

@Injectable()
export class WebSocketService extends StompRService {
  private ordersSubscription: Subscription;
  private stompMessages: Observable<Message>;

  // Usado para testar (debug) auto (re)conexão
  // private countTest: number = 0;

  constructor(
    private events: Events,
    private requestService: RequestService
  ) {
    super();
    this.subscribeStompState();
  }

  connect(): void {
    if (this.connected()) {
      this.events.publish('websocket:connected');
    } else {
      // Inicia configuração para conexão
      // https://stomp-js.github.io/ng2-stompjs/index.html
      // ----------------------------------------------------------------
      const stompConfig: StompConfig = {
        // url: () => new SockJS(this.countTest >= 10 ? APP_CONFIG.WEBSERVICE.WEBSOCKET : APP_CONFIG.WEBSERVICE.WEBSOCKET_ERROR_TEST),
        url: () => new SockJS(APP_CONFIG.WEBSERVICE.WEBSOCKET),
        headers: { access_token: this.requestService.getAuthToken() },
        heartbeat_in: 0, // Typical value 0 - disabled
        heartbeat_out: 20000, // Typical value 20000 - every 20 seconds
        reconnect_delay: 10000,
        debug: ENV.mode !== 'PROD',
      };
      this.config = stompConfig;
      this.initAndConnect();
    }
  }

  closeConnection(): void {
    try {
      if (this.client) {
        this.client.reconnect_delay = 0;
      }
      super.disconnect();
      console.log('disconnected');
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Faz o subscribe com um topico do websocket
   * @param uuid pode ser o uuid do Store ou do Place
   * @param type
   * @param messageCallback
   */
  subscribeTopic(uuid: string, type: WebSocketType, messageCallback: any): void {
    try {
      switch (type) {
        case WebSocketType.ORDERS:
          if (!this.ordersSubscription) {
            this.stompMessages = this.subscribe('/topic/' + uuid + '/order');
            this.ordersSubscription = this.stompMessages.subscribe(messageCallback);
          }
          break;

        default:
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }

  unsubscribeTopic(type: WebSocketType): void {
    try {
      switch (type) {
        case WebSocketType.ORDERS:
          if (this.ordersSubscription) {
            this.ordersSubscription.unsubscribe();
            this.ordersSubscription = null;
            this.stompMessages = null;
            console.log('unsubscribeTopic orders');
          }
          break;

        default:
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }

  private subscribeStompState(): void {
    try {
      this.state.subscribe((state: StompState) => {
        console.log(`Stomp connection status: ${state}`);
        switch (state) {
          case StompState.CONNECTED:
            this.events.publish('websocket:connected');
            break;

          case StompState.CLOSED:
            this.events.publish('websocket:closed');
            break;

          default:
            break;
        }
      });
      this.errorSubject.subscribe((message: Message | string) => {
        console.log(message);
        // this.countTest++;
      });
    } catch (error) {
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/websocket.service.ts